/**
 * 재무제표가 없는 DSD(정기보고서 본문)를 올렸을 때의 안내 문구.
 * 대사·변환·DSD 업로드 화면이 같은 백엔드 코드(DSD_SECTION_NOT_FOUND_ERROR)를 받으므로
 * 문구도 한 곳에서 관리한다.
 */
export const DSD_SECTION_NOT_FOUND_TITLE = "업로드할 수 없는 파일입니다.";

export const DSD_SECTION_NOT_FOUND_MESSAGE =
  "사업보고서·반기보고서·분기보고서는 업로드할 수 없습니다. 감사보고서 또는 검토보고서를 업로드해주세요.";

/** DART URL 변환은 파일을 올리는 흐름이 아니라 마지막 행동이 다르다. */
export const DSD_SECTION_NOT_FOUND_DART_URL_MESSAGE =
  "사업보고서·반기보고서·분기보고서는 업로드할 수 없습니다. 감사보고서 또는 검토보고서 URL을 복사해주세요.";

/** 모달은 문의 버튼을 함께 두므로 한 문장을 더 붙인다. */
export const DSD_SECTION_NOT_FOUND_MODAL_DESCRIPTION = `${DSD_SECTION_NOT_FOUND_MESSAGE} 파일이 맞다면 문의해 주세요.`;
